import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy from 'formsy-react';
import React, { Component } from 'react'
import { Container, Search, Grid, Header, Segment, Button, Message } from 'semantic-ui-react';
import { searchSubscribedSeller, setSellerPassword } from 'services/Manager';
import './SetSellerPasswordContainer.less'

const inititalState = {
    sellers: [],
    selectedSeller: {},
    searchingSellers: false,
    searchSellerPhrase: '',
    sellerID: 0,
    showPasswordResetForm: false,
    password: '',
    message: ''
}
class SetSellerPasswordContainer extends Component {

    constructor(props) {
        super(props);
        this.state = inititalState;
    }

    componentDidMount() {

    }

    onSearchSellerChange = (e, { value }) => {
        this.setState({ searchSellerPhrase: value, searchingSellers: true });
        if (this.searchSellerTimer)
            clearTimeout(this.searchSellerTimer);

        this.searchSellerTimer = setTimeout(() => {
            if (this.state.searchSellerPhrase.length > 0) {
                searchSubscribedSeller(this.state.searchSellerPhrase).then((response) => {
                    if (response.resStatus === 200) {
                        let sellers = [];
                        response.data.map((seller) => {
                            sellers.push({ id: seller.sellerID, title: seller.name, seoName: seller.seoName });
                        })

                        this.setState({ sellers: sellers });
                    }

                    this.setState({ searchingSellers: false });

                });
            }
            else {
                this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
            }
        }, 600)
    }

    onSellerSelect = async (e, { result } , setSellerName=false) => {
        this.setState({ sellerID: result.id, searchSellerPhrase: result.title, showPasswordResetForm: true });
    }

    onPasswordSubmit = async () => {
        const res = await setSellerPassword(this.state.sellerID, this.state.password);
        if(res.resStatus == 200){
            this.setState({message: 'Password has been saved successfully', password: ''})
        }
    }

    onPasswordChange = (e, data) => {
        this.setState({password: data.value});
    }

    render() {
        return (
            <Container fluid className="set-seller-password-container">
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header">
                            <div className="main-heading">
                                Set Seller Password
                            </div>
                        </div>
                        <Segment className="filter-segment">
                            <Formsy onValidSubmit={this.onSearch}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Search Seller</Header>
                                            <Search
                                                fluid
                                                className="seller-search search-box"
                                                loading={this.state.searchingSellers}
                                                minCharacters={1}
                                                onSearchChange={this.onSearchSellerChange}
                                                results={this.state.sellers}
                                                onResultSelect={this.onSellerSelect}
                                                value={this.state.searchSellerPhrase}

                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Formsy>
                        </Segment>
                        {this.state.sellerID > 0 && 
                        <Segment>
                            
                                <Grid>
                                    {this.state.message.length > 0 &&
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Message visible={this.state.message.length > 0} success>
                                                {this.state.message}
                                            </Message>
                                        </Grid.Column>
                                    </Grid.Row>
                                    }
                                    <Grid.Row>
                                        <Formsy onValidSubmit={this.onPasswordSubmit}>
                                        <Grid.Column width={16} className='password-container'>
                                            <div>
                                                <DGTextbox
                                                    name="password"
                                                    label="Password"
                                                    placeholder="Set new password"
                                                    type="password"
                                                    required
                                                    validationErrors={{
                                                        isDefaultRequiredValue: 'This field is required',
                                                        
                                                    }}
                                                    onChange={this.onPasswordChange}
                                                />
                                            </div>
                                            <div>
                                                <Button className='submit-button'>Submit</Button>
                                            </div>
                                        </Grid.Column>
                                        </Formsy>
                                    </Grid.Row>
                                </Grid>
                            
                        </Segment>
    }
                    </div>
                </div>

            </Container>
        )
    }
}

export default SetSellerPasswordContainer